export const STATUS = {
    pendente: { texto: 'Na fila', cor: 'blue-grey' },
    em_andamento: { texto: 'Em andamento', cor: 'blue' },
    concluido: { texto: 'Concluída', cor: 'green' },
    falhou: { texto: 'Falhou', cor: 'red' },
};

export const ETAPAS = {
    validando: 'conferindo os dois bancos',
    backup: 'gerando o backup do destino',
    copiando: 'apagando e copiando',
    sequences: 'ajustando as sequências',
};

export const TABELA = {
    pendente: { texto: 'Aguardando', cor: 'blue-grey lighten-3' },
    copiando: { texto: 'Copiando', cor: 'blue' },
    concluido: { texto: 'Copiada', cor: 'green' },
    desfeito: { texto: 'Desfeita', cor: 'orange' },
};

export function status(chave) {
    return STATUS[chave] || { texto: chave || '—', cor: 'grey' };
}

export function etapa(chave) {
    return ETAPAS[chave] || '';
}

export function tabela(chave) {
    return TABELA[chave] || { texto: chave || '—', cor: 'grey' };
}

export function bytes(total) {
    if (!total) return '—';

    const unidades = ['B', 'KB', 'MB', 'GB'];
    let valor = total;
    let i = 0;

    while (valor >= 1024 && i < unidades.length - 1) {
        valor /= 1024;
        i++;
    }

    return `${valor.toFixed(valor >= 10 || i === 0 ? 0 : 1)} ${unidades[i]}`;
}

export function duracao(ms) {
    if (!ms) return '—';
    if (ms < 1000) return `${ms} ms`;
    if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;

    const minutos = Math.floor(ms / 60000);
    const segundos = Math.round((ms % 60000) / 1000);

    return `${minutos}min ${segundos}s`;
}
